<template>
	<div v-loading="loading">
		<div v-empty="list.length === 0">
			<div class="log-items">
				<div class="log-items">
					<follow-record-cell
						v-for="(item, index) in list"
						:item="item"
						:crm-type="crmType"
						:index="index"
						:key="index"
						@on-handle="cellHandle"/>
					<div class="load">
						<el-button
							:loading="loadMoreLoading"
							type="text">{{ loadMoreLoading ? '加载更多' : '没有更多了' }}</el-button>
					</div>
				</div>
			</div>
		</div>
		<!-- dialog弹窗 -->
		<dialog-form
			:dialog-visible="dialogForm"
			:title="title"
			ref="crmform"  
			:crm-type="crmType"
			:action="action"
			:form-data="formData"
			@close = "closeDialog"
			@save-dialog="saveDialog">
		</dialog-form>
	</div>
</template>

<script>
	import FollowRecordCell from './components/FollowRecordCell' // 跟进记录
	import { crmRecordIndex } from '@/api/customer/common'
	import { crmlogsUpdate } from '@/api/customer/customer'
	export default {
		/** 线索管理 的 线索详情 的 跟进记录*/
		name: 'RecordLog',
		components: {
			FollowRecordCell,
			'DialogForm': () => import('@/components/FromData/dialogForm.vue')
		},
		props: {
			/** 模块ID */
			id: [String, Number],
			/** 没有值就是全部类型 有值就是当个类型 */
			crmType: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				loading: false,
				loadMoreLoading: true,
				isPost: false,
				page: 1,
				list: [] ,// 跟进记录列表
				
				// dialog弹窗
				dialogForm:false,
				title:"",
				dialogType:"",
				action:{ type: '',actiontype:'',relevant:'' },
				formData:{}
			}
		},
		computed: {},
		watch: {
			id: function(val) {
				this.refreshList()
			}
		},
		mounted() {
			this.$bus.on('follow-log-refresh', data => {
			  if (data.type == 'record-log') {
			    this.refreshList()
			  }
			})
			
			
			
			//分批次加载
			window.addEventListener('scroll',()=>{
				const scrollOff = document.documentElement.scrollTop + document.documentElement.clientHeight - document.documentElement.scrollHeight
				// 滚动条到底部的条件
				if (Math.abs(scrollOff) < 10 && this.loadMoreLoading == true) {
				  if (!this.isPost) {
				    this.isPost = true
				    this.page++
				    this.getList()
				  } else {
				    this.loadMoreLoading = false
				  }
				}
			})
			
			this.getList()
			// this.refreshList()
		},
		activated: function() {},
		deactivated: function() {},
		beforeDestroy() {
			this.$bus.off('follow-log-refresh')
		},
		
		methods: {
			refreshList() {
				this.page = 1
				this.list = []
				this.getList()
			},
			
			getList() {
				this.loading = true
				crmRecordIndex({
					page: this.page,
					limit: 10,
					types: 'crm_' + this.crmType,
					types_id: this.id,
					by: 'record' // 类型（record 跟进记录，log 日志、examine审批、task 任务、event日程、默认是全部）
				})
			    .then(res => {
					this.list = this.list.concat(res.data.list)
					if (res.data.list.length < 10) {
						this.loadMoreLoading = false
					} else {
						this.loadMoreLoading = true
					}
					this.loading = false
					this.isPost = false
			    })
			    .catch(() => {
					this.isPost = false
					this.loading = false
			    })
			},
			
			/**
			 * 行布局删除
			 */
			cellHandle(item) {
				if(item.type == "update"){
					this.title = "修改信息"
					this.dialogForm = true
					this.action = { type: 'update',relevant:"log",actiontype:18 }
					this.formData = JSON.parse(JSON.stringify(item.data))
				}else if(item.type == "delete"){
					this.list = []
					this.getList()
				}
				
			},
			
			// 弹窗操作
			closeDialog(){
				this.title = ""
				this.dialogForm = false
				this.formData = {}
			},
			
			// 保存操作
			saveDialog(item){
				let data = item.data
				// data["customer_id"] = item.data.customer_id
				let request
				if(item.type == "update_log"){
					request = crmlogsUpdate
				}
				
				request(data)
					.then(res => {
						this.$message.success(res.data)
						this.closeDialog()
						this.list = []
						this.getList()
					})
			}
			
		}
	}
</script>

<style lang="scss" scoped>
	.log-items {
		min-height: 400px;
		position: relative;
	}

	.load {
		color: #999;
		font-size: 13px;
		margin: 0 auto 15px;
		text-align: center;

		.el-button,
		.el-button:focus {
			color: #ccc;
			cursor: auto;
		}
	}
</style>
